import styled from 'styled-components'
import { tokens } from 'styling/tokens'
import { OtherText } from 'styling/Typography'

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 1rem 0;
`

export const SearchWrap = styled.div`
  width: 18rem;
  max-width: 100%;
`

export const ReportCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`

export const ReportId = styled.span`
  font-family: ui-monospace, 'SF Mono', Menlo, monospace;
  font-size: ${tokens.font.label};
  font-variant-numeric: tabular-nums;
  color: ${tokens.text.muted};
`

export const TonnesPct = styled.span<{ $tone: 'success' | 'warning' | 'danger' }>`
  font-size: ${tokens.font.label};
  font-weight: 600;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
  color: ${({ $tone }) => tokens.status[$tone].fg};
`

export const AvailabilityText = styled.span<{ $tone: 'success' | 'neutral' | 'danger' }>`
  font-size: ${tokens.font.body};
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: ${({ $tone }) => tokens.status[$tone].fg};
`

export const LockGlyph = styled.span`
  display: inline-flex;
  align-items: center;
  margin-right: 0.4rem;
`

export const Footnote = styled(OtherText)`
  margin-top: 0.75rem;
  color: ${tokens.text.muted};
`
